import React, { useEffect, useState } from 'react';

export default function Ticker({ from, end, duration = 3000 }) {
    const [count, setCount] = useState(from);
    useEffect(() => {
        let start = null;
        const step = (timestamp) => {
            if (!start) start = timestamp;
            const progress = timestamp - start;
            const increment = Math.ceil(((end - from) / duration) * progress);
            if (count + increment < end)
            {
                setCount((count + increment).toLocaleString('en-US'));
                window.requestAnimationFrame(step);
            } else {
                setCount(end.toLocaleString('en-US'));
            }
        };
        window.requestAnimationFrame(step);
    }, [from, end, duration]);
    return <>{count}</>;
}
